let amplifyConfigPromise;

export async function ensureAmplifyConfigured() {
    if (!amplifyConfigPromise) {
        amplifyConfigPromise = (async () => {
            const [{Amplify}, {default: config}] = await Promise.all([
                import('aws-amplify'),
                import('../config'),
            ]);

            Amplify.configure({
                Auth: {
                    Cognito: {
                        mandatorySignIn: false,
                        region: config.cognito.REGION,
                        identityPoolId: config.cognito.IDENTITY_POOL_ID,
                    },
                },
                Storage: {
                    region: config.s3.REGION,
                    bucket: config.s3.BUCKET,
                    identityPoolId: config.cognito.IDENTITY_POOL_ID,
                },
                API: {
                    REST: {
                        ordering: {
                            endpoint: config.apiGateway.URL,
                            region: config.apiGateway.REGION,
                        },
                    },
                },
            });
        })();
    }

    await amplifyConfigPromise;
}

export async function getAmplifyApi() {
    await ensureAmplifyConfigured();
    return import('aws-amplify/api');
}

export async function getAmplifyAuth() {
    await ensureAmplifyConfigured();
    return import('aws-amplify/auth');
}
